import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map } from 'rxjs/operators';
import { of } from 'rxjs';

import * as LocationHistoryActions from '../actions/location-history.actions';
import { LocationHistoryService } from '../../services/location-history.service';

@Injectable()
export class LocationHistoryEffects {
  loadLocationHistory$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LocationHistoryActions.loadLocationHistory),
      concatMap(({ payload }) =>
        this.locationHistoryService.loadAllVehicleHistoryData(payload).pipe(
          map((locationHistoryList) =>
            LocationHistoryActions.loadLocationHistorySuccess({
              locationHistoryList,
            }),
          ),
          catchError((error) =>
            of(LocationHistoryActions.loadLocationHistoryFailure({ error })),
          ),
        ),
      ),
    );
  });

  loadLocationHistoryStats$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LocationHistoryActions.loadLocationHistoryStats),
      concatMap(({ payload }) =>
        this.locationHistoryService.getVehicleLocationStatistics(payload).pipe(
          map((locationStats) =>
            LocationHistoryActions.loadLocationHistoryStatsSuccess({
              payload: locationStats,
            }),
          ),
          catchError((error) =>
            of(LocationHistoryActions.loadLocationHistoryFailure({ error })),
          ),
        ),
      ),
    );
  });

  getCurrentVehicleHistory$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LocationHistoryActions.getCurrentVehicleHistory),
      concatMap(({ payload }) =>
        this.locationHistoryService.loadAllVehicleHistoryData(payload).pipe(
          map((locationStats) =>
            LocationHistoryActions.getCurrentVehicleHistorySuccess({
              payload: locationStats,
            }),
          ),
          catchError((error) =>
            of(LocationHistoryActions.loadLocationHistoryFailure({ error })),
          ),
        ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private locationHistoryService: LocationHistoryService,
  ) {}
}
